import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { RentalPortalApplicantProfileWidgetAttention } from '../../../RentalPortalApplicantProfileWidgetAttention'
import { RentalPortalApplicantProfileWidgetMatchedListing } from '../../../RentalPortalApplicantProfileWidgetMatchedListing'
import { RentalPortalApplicantProfileWidgetStageScreening } from '../../../RentalPortalApplicantProfileWidgetStageScreening'
import { APPLICANT_PROFILE_WIDGET_KEY } from '../../RentalPortalApplicantProfileWidgetList.constants'
import { getHasApplicantMatchedListing } from '../../RentalPortalApplicantProfileWidgetList.utils'

export function useApplicantProfileWidgets() {
  const { applicantData, isInitiated } = useApplicantProfileContext()

  const widgets = {
    [APPLICANT_PROFILE_WIDGET_KEY.attention]: (
      <RentalPortalApplicantProfileWidgetAttention />
    ),
    [APPLICANT_PROFILE_WIDGET_KEY.matchedListing]:
      !isInitiated || getHasApplicantMatchedListing(applicantData) ? (
        <RentalPortalApplicantProfileWidgetMatchedListing />
      ) : null,
    [APPLICANT_PROFILE_WIDGET_KEY.stageScreening]: (
      <RentalPortalApplicantProfileWidgetStageScreening />
    ),
  }

  return { widgets }
}
